// Helper functions for quote command

export function isBlockquote(element) {
  return element.tagName === "BLOCKQUOTE";
}

export function getBlockElements(root) {
  const blockTags = [
    "P",
    "DIV",
    "H1",
    "H2",
    "H3",
    "H4",
    "H5",
    "H6",
    "BLOCKQUOTE",
    "UL",
    "OL",
    "LI",
  ];
  const blocks = [];

  function traverse(node) {
    if (node instanceof HTMLElement && blockTags.includes(node.tagName)) {
      blocks.push(node);
    } else if (node.childNodes.length > 0) {
      node.childNodes.forEach(traverse);
    }
  }

  traverse(root);
  return blocks;
}

export function findParentBlock(
  node,
  root,
) {
  let current = node;

  while (current && current !== root) {
    if (current instanceof HTMLElement && isBlockElement(current)) {
      return current;
    }
    current = current.parentNode;
  }

  return null;
}

function isBlockElement(element) {
  const blockTags = [
    "P",
    "DIV",
    "H1",
    "H2",
    "H3",
    "H4",
    "H5",
    "H6",
    "BLOCKQUOTE",
    "UL",
    "OL",
    "LI",
  ];
  return blockTags.includes(element.tagName);
}

export const isBlockquoteFullySelected = (range, bq) => {
  const tempRange = document.createRange();
  tempRange.selectNodeContents(bq);

  return (
    range.compareBoundaryPoints(Range.START_TO_START, tempRange) <= 0 &&
    range.compareBoundaryPoints(Range.END_TO_END, tempRange) >= 0
  );
};

export const getFullySelectedBlockquotes = (range) => {
  const blockquotes = Array.from(document.querySelectorAll("blockquote"));

  return blockquotes.filter((bq) => {
    if (!range.intersectsNode(bq)) return false;
    return isBlockquoteFullySelected(range, bq);
  });
};

export const checkIsBlockQuote = ({ blocks }) => {
  return blocks.some((b) => {
    if (!(b instanceof HTMLElement)) return false;

    return (
      b.tagName.toLowerCase() === "blockquote" ||
      (b.parentNode instanceof HTMLElement &&
        b.parentNode.tagName.toLowerCase() === "blockquote")
    );
  });
};
